import { Reveal, SectionLabel } from "./Reveal";
import { Icon } from "@/lib/icons";

export default function WhyChoose({ site }) {
  const w = site?.why || {};
  return (
    <section id="why" className="py-24 lg:py-32 bg-[var(--c-bg-alt)]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <SectionLabel>{w.label}</SectionLabel>
          <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{w.title}</h2>
          <p className="font-body text-[var(--c-muted)] mt-5 text-base sm:text-lg">{w.subtitle}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {(w.items || []).map((it, i) => (
            <Reveal key={i} delay={(i % 3) * 0.08}>
              <div
                data-testid={`why-card-${i}`}
                className="group h-full bg-[var(--c-card)] rounded-2xl border border-[var(--c-border)] p-8 hover:border-[var(--c-accent)] hover:shadow-[0_20px_50px_-25px_rgba(106,27,26,0.4)] transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1"
              >
                <span className="grid place-items-center h-14 w-14 rounded-2xl bg-[var(--c-primary)]/5 text-[var(--c-primary)] group-hover:bg-[var(--c-primary)] group-hover:text-white transition-colors">
                  <Icon name={it.icon} className="h-6 w-6" />
                </span>
                <h3 className="font-heading text-xl font-semibold text-[var(--c-primary)] mt-6">{it.title}</h3>
                <p className="font-body text-[var(--c-muted)] mt-3 leading-relaxed">{it.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
